module.exports = __webpack_public_path__ + "img/xiaochengxu_1.27e7bcef.png";